<template>
	<div class="akpk-card">
		<b-card no-body>
			<b-card-header class="py-2 px-3">
				<h3 class="mb-0">AKPK</h3>
			</b-card-header>
			<div v-if="tableData.length > 0" class="card-table rounded-bottom">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="akpk_approved_date" label="Date" min-width="150" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.akpk_approved_date }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="akpk_loan_statue" label="Facility" min-width="150" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.akpk_loan_statue }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="akpk_current_outstanding" label="Outstanding Balance (RM)" min-width="250" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.akpk_current_outstanding | moneyFormatter }}</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else class="bg-light p-3 text-center rounded-bottom">
				<p class="text-xs">No AKPK recorded</p>
			</div>
		</b-card>
	</div>
</template>
<script>
import { Card, Button, Table, TableColumn } from 'element-ui'

export default {
	name: 'akpk-card',
	props: ['akpk_card'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Card.name] : Card,
		[Button.name] : Button
	},
	data() {
		return {
			tableData: this.akpk_card
		}
	}
}
</script>